/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.4.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming



export class AuthenticateRequest implements IAuthenticateRequest {
    email!: string;
    password!: string;

    constructor(data?: IAuthenticateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AuthenticateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data; 
    }
}

export interface IAuthenticateRequest {
    email: string;
    password: string;
}

export class AuthenticateResponse implements IAuthenticateResponse {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    role?: Role;
    created?: Date;
    updated?: Date | undefined;
    isVerified?: boolean;
    jwtToken?: string | undefined;
    electronicInvoiceAgreed?: boolean;

    constructor(data?: IAuthenticateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.role = _data["role"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.updated = _data["updated"] ? new Date(_data["updated"].toString()) : <any>undefined;
            this.isVerified = _data["isVerified"];
            this.jwtToken = _data["jwtToken"];
            this.electronicInvoiceAgreed = _data["electronicInvoiceAgreed"];
        }
    }

    static fromJS(data: any): AuthenticateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AuthenticateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["role"] = this.role;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["updated"] = this.updated ? this.updated.toISOString() : <any>undefined;
        data["isVerified"] = this.isVerified;
        data["jwtToken"] = this.jwtToken;
        data["electronicInvoiceAgreed"] = this.electronicInvoiceAgreed;
        return data; 
    }
}

export interface IAuthenticateResponse {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    role?: Role;
    created?: Date;
    updated?: Date | undefined;
    isVerified?: boolean;
    jwtToken?: string | undefined;
    electronicInvoiceAgreed?: boolean;
}

export class ContactFormDto implements IContactFormDto {
    id?: number;
    accountId?: number | undefined;
    email?: string | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    submitDate?: Date;
    sentDate?: Date | undefined;
    status?: FormStatusEnum;

    constructor(data?: IContactFormDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.email = _data["email"];
            this.subject = _data["subject"];
            this.content = _data["content"];
            this.submitDate = _data["submitDate"] ? new Date(_data["submitDate"].toString()) : <any>undefined;
            this.sentDate = _data["sentDate"] ? new Date(_data["sentDate"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ContactFormDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactFormDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["email"] = this.email;
        data["subject"] = this.subject;
        data["content"] = this.content;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data; 
    }
}

export interface IContactFormDto {
    id?: number;
    accountId?: number | undefined;
    email?: string | undefined;
    subject?: string | undefined;
    content?: string | undefined;
    submitDate?: Date;
    sentDate?: Date | undefined;
    status?: FormStatusEnum;
}

export class ContainerDto implements IContainerDto {
    id?: number;
    name?: string | undefined;
    number?: number;
    kind?: string | undefined;

    constructor(data?: IContainerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.kind = _data["kind"];
        }
    }

    static fromJS(data: any): ContainerDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["number"] = this.number;
        data["kind"] = this.kind;
        return data; 
    }
}

export interface IContainerDto {
    id?: number;
    name?: string | undefined;
    number?: number;
    kind?: string | undefined;
}

export class ContractDto implements IContractDto {
    id?: number;
    contractType?: ContractTypeEnum;
    contractDate?: Date;
    contractNumber?: string | undefined;
    currentDue?: number;
    bankAccountNumber?: string | undefined;
    lastChanged?: Date;
    meters?: MeterDto[] | undefined;
    containers?: ContainerDto[] | undefined;
    street?: string | undefined;
    streetNum?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;

    constructor(data?: IContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractType = _data["contractType"];
            this.contractDate = _data["contractDate"] ? new Date(_data["contractDate"].toString()) : <any>undefined;
            this.contractNumber = _data["contractNumber"];
            this.currentDue = _data["currentDue"];
            this.bankAccountNumber = _data["bankAccountNumber"];
            this.lastChanged = _data["lastChanged"] ? new Date(_data["lastChanged"].toString()) : <any>undefined;
            if (Array.isArray(_data["meters"])) {
                this.meters = [] as any;
                for (let item of _data["meters"])
                    this.meters!.push(MeterDto.fromJS(item));
            }
            if (Array.isArray(_data["containers"])) {
                this.containers = [] as any;
                for (let item of _data["containers"])
                    this.containers!.push(ContainerDto.fromJS(item));
            }
            this.street = _data["street"];
            this.streetNum = _data["streetNum"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): ContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractType"] = this.contractType;
        data["contractDate"] = this.contractDate ? this.contractDate.toISOString() : <any>undefined;
        data["contractNumber"] = this.contractNumber;
        data["currentDue"] = this.currentDue;
        data["bankAccountNumber"] = this.bankAccountNumber;
        data["lastChanged"] = this.lastChanged ? this.lastChanged.toISOString() : <any>undefined;
        if (Array.isArray(this.meters)) {
            data["meters"] = [];
            for (let item of this.meters)
                data["meters"].push(item.toJSON());
        }
        if (Array.isArray(this.containers)) {
            data["containers"] = [];
            for (let item of this.containers)
                data["containers"].push(item.toJSON());
        }
        data["street"] = this.street;
        data["streetNum"] = this.streetNum;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        return data; 
    }
}

export interface IContractDto {
    id?: number;
    contractType?: ContractTypeEnum;
    contractDate?: Date;
    contractNumber?: string | undefined;
    currentDue?: number;
    bankAccountNumber?: string | undefined;
    lastChanged?: Date;
    meters?: MeterDto[] | undefined;
    containers?: ContainerDto[] | undefined;
    street?: string | undefined;
    streetNum?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
}

export class ContractSummaryInfoDto implements IContractSummaryInfoDto {
    name?: string | undefined;
    currentDueCaption?: string | undefined;
    currentDueValue?: number | undefined;
    paymentCaption?: string | undefined;
    paymentDate?: string | undefined;
    overdueCaption?: string | undefined;
    overdueValue?: number | undefined;
    overpaidCaption?: string | undefined;
    overpaidValue?: number | undefined;

    constructor(data?: IContractSummaryInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.currentDueCaption = _data["currentDueCaption"];
            this.currentDueValue = _data["currentDueValue"];
            this.paymentCaption = _data["paymentCaption"];
            this.paymentDate = _data["paymentDate"];
            this.overdueCaption = _data["overdueCaption"];
            this.overdueValue = _data["overdueValue"];
            this.overpaidCaption = _data["overpaidCaption"];
            this.overpaidValue = _data["overpaidValue"];
        }
    }

    static fromJS(data: any): ContractSummaryInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSummaryInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["currentDueCaption"] = this.currentDueCaption;
        data["currentDueValue"] = this.currentDueValue;
        data["paymentCaption"] = this.paymentCaption;
        data["paymentDate"] = this.paymentDate;
        data["overdueCaption"] = this.overdueCaption;
        data["overdueValue"] = this.overdueValue;
        data["overpaidCaption"] = this.overpaidCaption;
        data["overpaidValue"] = this.overpaidValue;
        return data; 
    }
}

export interface IContractSummaryInfoDto {
    name?: string | undefined;
    currentDueCaption?: string | undefined;
    currentDueValue?: number | undefined;
    paymentCaption?: string | undefined;
    paymentDate?: string | undefined;
    overdueCaption?: string | undefined;
    overdueValue?: number | undefined;
    overpaidCaption?: string | undefined;
    overpaidValue?: number | undefined;
}

export enum ContractTypeEnum {
    Water = "Water",
    Waste = "Waste",
    Another = "Another",
}

export class ContractWithDetailsDto implements IContractWithDetailsDto {
    contract?: ContractDto;
    meters?: MeterDto[] | undefined;
    containers?: ContainerDto[] | undefined;
    bankAccount?: string | undefined;

    constructor(data?: IContractWithDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contract = _data["contract"] ? ContractDto.fromJS(_data["contract"]) : <any>undefined;
            if (Array.isArray(_data["meters"])) {
                this.meters = [] as any;
                for (let item of _data["meters"])
                    this.meters!.push(MeterDto.fromJS(item));
            }
            if (Array.isArray(_data["containers"])) {
                this.containers = [] as any;
                for (let item of _data["containers"])
                    this.containers!.push(ContainerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractWithDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContractWithDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contract"] = this.contract ? this.contract.toJSON() : <any>undefined;
        if (Array.isArray(this.meters)) {
            data["meters"] = [];
            for (let item of this.meters)
                data["meters"].push(item.toJSON());
        }
        if (Array.isArray(this.containers)) {
            data["containers"] = [];
            for (let item of this.containers)
                data["containers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IContractWithDetailsDto {
    contract?: ContractDto;
    meters?: MeterDto[] | undefined;
    containers?: ContainerDto[] | undefined;
    bankAccount?: string;
}

export class CustomerDto implements ICustomerDto {
    id?: number;
    accountId?: number;
    name?: string | undefined;
    code?: string | undefined;
    vatid?: string | undefined;
    lastChange?: Date;
    eFaktura?: boolean;
    eFakturaFrom?: Date | undefined;
    eFakturaTo?: Date | undefined;
    bankAccountWater?: string | undefined;
    bankAccountWastes?: string | undefined;
    street?: string | undefined;
    streetNum?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.name = _data["name"];
            this.code = _data["code"];
            this.vatid = _data["vatid"];
            this.lastChange = _data["lastChange"] ? new Date(_data["lastChange"].toString()) : <any>undefined;
            this.eFaktura = _data["eFaktura"];
            this.eFakturaFrom = _data["eFakturaFrom"] ? new Date(_data["eFakturaFrom"].toString()) : <any>undefined;
            this.eFakturaTo = _data["eFakturaTo"] ? new Date(_data["eFakturaTo"].toString()) : <any>undefined;
            this.bankAccountWater = _data["bankAccountWater"];
            this.bankAccountWastes = _data["bankAccountWastes"];
            this.street = _data["street"];
            this.streetNum = _data["streetNum"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["name"] = this.name;
        data["code"] = this.code;
        data["vatid"] = this.vatid;
        data["lastChange"] = this.lastChange ? this.lastChange.toISOString() : <any>undefined;
        data["eFaktura"] = this.eFaktura;
        data["eFakturaFrom"] = this.eFakturaFrom ? this.eFakturaFrom.toISOString() : <any>undefined;
        data["eFakturaTo"] = this.eFakturaTo ? this.eFakturaTo.toISOString() : <any>undefined;
        data["bankAccountWater"] = this.bankAccountWater;
        data["bankAccountWastes"] = this.bankAccountWastes;
        data["street"] = this.street;
        data["streetNum"] = this.streetNum;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        return data; 
    }
}

export interface ICustomerDto {
    id?: number;
    accountId?: number;
    name?: string | undefined;
    code?: string | undefined;
    vatid?: string | undefined;
    lastChange?: Date;
    eFaktura?: boolean;
    eFakturaFrom?: Date | undefined;
    eFakturaTo?: Date | undefined;
    bankAccountWater?: string | undefined;
    bankAccountWastes?: string | undefined;
    street?: string | undefined;
    streetNum?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
}

export class CustomerValidationReqeuest implements ICustomerValidationReqeuest {
    customerNo?: string | undefined;
    invoiceNumber?: string | undefined;
    invoiceAmount?: number;

    constructor(data?: ICustomerValidationReqeuest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerNo = _data["customerNo"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.invoiceAmount = _data["invoiceAmount"];
        }
    }

    static fromJS(data: any): CustomerValidationReqeuest {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerValidationReqeuest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerNo"] = this.customerNo;
        data["invoiceNumber"] = this.invoiceNumber;
        data["invoiceAmount"] = this.invoiceAmount;
        return data; 
    }
}

export interface ICustomerValidationReqeuest {
    customerNo?: string | undefined;
    invoiceNumber?: string | undefined;
    invoiceAmount?: number;
}

export class DeclarationDto implements IDeclarationDto {
    id?: number;
    accountId?: number;
    customerId?: number;
    contractId?: number;
    content?: string | undefined;
    submitDate?: Date;
    sentDate?: Date | undefined;
    status?: FormStatusEnum;

    constructor(data?: IDeclarationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountId = _data["accountId"];
            this.customerId = _data["customerId"];
            this.contractId = _data["contractId"];
            this.content = _data["content"];
            this.submitDate = _data["submitDate"] ? new Date(_data["submitDate"].toString()) : <any>undefined;
            this.sentDate = _data["sentDate"] ? new Date(_data["sentDate"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): DeclarationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeclarationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountId"] = this.accountId;
        data["customerId"] = this.customerId;
        data["contractId"] = this.contractId;
        data["content"] = this.content;
        data["submitDate"] = this.submitDate ? this.submitDate.toISOString() : <any>undefined;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data; 
    }
}

export interface IDeclarationDto {
    id?: number;
    accountId?: number;
    customerId?: number;
    contractId?: number;
    content?: string | undefined;
    submitDate?: Date;
    sentDate?: Date | undefined;
    status?: FormStatusEnum;
}

export class Document implements IDocument {
    id?: number;
    contractId?: number;
    customerId?: number;
    number?: string | undefined;
    valueTotalGross?: number;
    valueTotalNetto?: number;
    valuePaid?: number;
    dateSale?: Date;
    documentType?: string | undefined;
    dueDate?: Date;
    readonly dueValue?: number;
    relatedDocuments?: string | undefined;
    relatedDocumentIds?: number[] | undefined;

    constructor(data?: IDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractId = _data["contractId"];
            this.customerId = _data["customerId"];
            this.number = _data["number"];
            this.valueTotalGross = _data["valueTotalGross"];
            this.valueTotalNetto = _data["valueTotalNetto"];
            this.valuePaid = _data["valuePaid"];
            this.dateSale = _data["dateSale"] ? new Date(_data["dateSale"].toString()) : <any>undefined;
            this.documentType = _data["documentType"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            (<any>this).dueValue = _data["dueValue"];
            this.relatedDocuments = _data["relatedDocuments"];
            if (Array.isArray(_data["relatedDocumentIds"])) {
                this.relatedDocumentIds = [] as any;
                for (let item of _data["relatedDocumentIds"])
                    this.relatedDocumentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractId"] = this.contractId;
        data["customerId"] = this.customerId;
        data["number"] = this.number;
        data["valueTotalGross"] = this.valueTotalGross;
        data["valueTotalNetto"] = this.valueTotalNetto;
        data["valuePaid"] = this.valuePaid;
        data["dateSale"] = this.dateSale ? this.dateSale.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["dueValue"] = this.dueValue;
        data["relatedDocuments"] = this.relatedDocuments;
        if (Array.isArray(this.relatedDocumentIds)) {
            data["relatedDocumentIds"] = [];
            for (let item of this.relatedDocumentIds)
                data["relatedDocumentIds"].push(item);
        }
        return data; 
    }
}

export interface IDocument {
    id?: number;
    contractId?: number;
    customerId?: number;
    number?: string | undefined;
    valueTotalGross?: number;
    valueTotalNetto?: number;
    valuePaid?: number;
    dateSale?: Date;
    documentType?: string | undefined;
    dueDate?: Date;
    dueValue?: number;
    relatedDocuments?: string | undefined;
    relatedDocumentIds?: number[] | undefined;
}

export class DocumentDto implements IDocumentDto {
    id?: number;
    contractId?: number;
    number?: string | undefined;
    valueTotalGross?: number;
    valueTotalNetto?: number;
    valuePaid?: number;
    dateSale?: Date;
    dueDate?: Date;
    documentType?: DocumentTypeEnum;
    downloadAllowed?: boolean;
    customerId?: number;

    constructor(data?: IDocumentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractId = _data["contractId"];
            this.number = _data["number"];
            this.valueTotalGross = _data["valueTotalGross"];
            this.valueTotalNetto = _data["valueTotalNetto"];
            this.valuePaid = _data["valuePaid"];
            this.dateSale = _data["dateSale"] ? new Date(_data["dateSale"].toString()) : <any>undefined;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : <any>undefined;
            this.documentType = _data["documentType"];
            this.downloadAllowed = _data["downloadAllowed"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): DocumentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractId"] = this.contractId;
        data["number"] = this.number;
        data["valueTotalGross"] = this.valueTotalGross;
        data["valueTotalNetto"] = this.valueTotalNetto;
        data["valuePaid"] = this.valuePaid;
        data["dateSale"] = this.dateSale ? this.dateSale.toISOString() : <any>undefined;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
        data["documentType"] = this.documentType;
        data["downloadAllowed"] = this.downloadAllowed;
        data["customerId"] = this.customerId;
        return data; 
    }
}

export interface IDocumentDto {
    id?: number;
    contractId?: number;
    number?: string | undefined;
    valueTotalGross?: number;
    valueTotalNetto?: number;
    valuePaid?: number;
    dateSale?: Date;
    dueDate?: Date;
    documentType?: DocumentTypeEnum;
    downloadAllowed?: boolean;
    customerId?: number;
}

export enum DocumentTypeEnum {
    Invoice = "Invoice",
    InterestNote = "InterestNote",
    Correction = "Correction",
}

export enum FieldTypeEnum {
    Number = "Number",
    Text = "Text",
    TextArea = "TextArea",
    Date = "Date",
    File = "File",
    CheckBox = "CheckBox",
    RemarkHeader = "RemarkHeader",
    Remark = "Remark",
    RadioButton = "RadioButton",
    BankAccountNumber = "BankAccountNumber"
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
    email!: string;

    constructor(data?: IForgotPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForgotPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data; 
    }
}

export interface IForgotPasswordRequest {
    email: string;
}

export enum FormStatusEnum {
    New = "New",
    Sent = "Sent",
    Error = "Error",
}

export class FormSubjectDto implements IFormSubjectDto {
    id?: number;
    title?: string | undefined;
    targetEmail?: string | undefined;
    order?: number;

    constructor(data?: IFormSubjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.targetEmail = _data["targetEmail"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): FormSubjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormSubjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["targetEmail"] = this.targetEmail;
        data["order"] = this.order;
        return data; 
    }
}

export interface IFormSubjectDto {
    id?: number;
    title?: string | undefined;
    targetEmail?: string | undefined;
    order?: number;
}

export class FormTemplateDto implements IFormTemplateDto {
    id?: number;
    formSubjectId?: number;
    title?: string | undefined;
    fieldType?: FieldTypeEnum;
    isRequired?: boolean;
    max?: number;
    order?: number;
    name?: string | undefined;

    constructor(data?: IFormTemplateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formSubjectId = _data["formSubjectId"];
            this.title = _data["title"];
            this.fieldType = _data["fieldType"];
            this.isRequired = _data["isRequired"];
            this.max = _data["max"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): FormTemplateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormTemplateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formSubjectId"] = this.formSubjectId;
        data["title"] = this.title;
        data["fieldType"] = this.fieldType;
        data["isRequired"] = this.isRequired;
        data["max"] = this.max;
        data["order"] = this.order;
        return data; 
    }
}

export interface IFormTemplateDto {
    id?: number;
    formSubjectId?: number;
    title?: string | undefined;
    fieldType?: FieldTypeEnum;
    isRequired?: boolean;
    max?: number;
    order?: number;
    name?: string | undefined;
}

export class MessageDto implements IMessageDto {
    id?: number;
    subject?: string | undefined;
    contentText?: string | undefined;
    publicationDate?: Date;
    deactivationDate?: Date | undefined;

    constructor(data?: IMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subject = _data["subject"];
            this.contentText = _data["contentText"];
            this.publicationDate = _data["publicationDate"] ? new Date(_data["publicationDate"].toString()) : <any>undefined;
            this.deactivationDate = _data["deactivationDate"] ? new Date(_data["deactivationDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new MessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subject"] = this.subject;
        data["contentText"] = this.contentText;
        data["publicationDate"] = this.publicationDate ? this.publicationDate.toISOString() : <any>undefined;
        data["deactivationDate"] = this.deactivationDate ? this.deactivationDate.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IMessageDto {
    id?: number;
    subject?: string | undefined;
    contentText?: string | undefined;
    publicationDate?: Date;
    deactivationDate?: Date | undefined;
}

export class MeterDto implements IMeterDto {
    id?: number;
    contractId?: number;
    number?: string | undefined;
    latestValue?: number | undefined;
    master?: boolean;
    latestReadTime?: Date | undefined;
    latestConsumption?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    street?: string | undefined;
    streetNum?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;

    constructor(data?: IMeterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contractId = _data["contractId"];
            this.number = _data["number"];
            this.latestValue = _data["latestValue"];
            this.master = _data["master"];
            this.latestReadTime = _data["latestReadTime"] ? new Date(_data["latestReadTime"].toString()) : <any>undefined;
            this.latestConsumption = _data["latestConsumption"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.street = _data["street"];
            this.streetNum = _data["streetNum"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): MeterDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contractId"] = this.contractId;
        data["number"] = this.number;
        data["latestValue"] = this.latestValue;
        data["master"] = this.master;
        data["latestReadTime"] = this.latestReadTime ? this.latestReadTime.toISOString() : <any>undefined;
        data["latestConsumption"] = this.latestConsumption;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["street"] = this.street;
        data["streetNum"] = this.streetNum;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        return data; 
    }
}

export interface IMeterDto {
    id?: number;
    contractId?: number;
    number?: string | undefined;
    latestValue?: number | undefined;
    master?: boolean;
    latestReadTime?: Date | undefined;
    latestConsumption?: number | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    street?: string | undefined;
    streetNum?: string | undefined;
    city?: string | undefined;
    zipCode?: string | undefined;
}

export class MeterRead implements IMeterRead {
    id?: number;
    meterId?: number;
    value?: number;
    readDate?: Date;
    consumption?: number;

    constructor(data?: IMeterRead) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.meterId = _data["meterId"];
            this.value = _data["value"];
            this.readDate = _data["readDate"] ? new Date(_data["readDate"].toString()) : <any>undefined;
            this.consumption = _data["consumption"];
        }
    }

    static fromJS(data: any): MeterRead {
        data = typeof data === 'object' ? data : {};
        let result = new MeterRead();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meterId"] = this.meterId;
        data["value"] = this.value;
        data["readDate"] = this.readDate ? this.readDate.toISOString() : <any>undefined;
        data["consumption"] = this.consumption;
        return data; 
    }
}

export interface IMeterRead {
    id?: number;
    meterId?: number;
    value?: number;
    readDate?: Date;
    consumption?: number;
}

export class MeterReadDto implements IMeterReadDto {
    id?: number;
    meterId?: number;
    value?: number;
    readDate?: Date;
    consumption?: number;

    constructor(data?: IMeterReadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.meterId = _data["meterId"];
            this.value = _data["value"];
            this.readDate = _data["readDate"] ? new Date(_data["readDate"].toString()) : <any>undefined;
            this.consumption = _data["consumption"];
        }
    }

    static fromJS(data: any): MeterReadDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeterReadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["meterId"] = this.meterId;
        data["value"] = this.value;
        data["readDate"] = this.readDate ? this.readDate.toISOString() : <any>undefined;
        data["consumption"] = this.consumption;
        return data; 
    }
}

export interface IMeterReadDto {
    id?: number;
    meterId?: number;
    value?: number;
    readDate?: Date;
    consumption?: number;
}

export class MeterWithMeterReadsDto implements IMeterWithMeterReadsDto {
    meter?: MeterDto;
    meterReads?: MeterReadDto[] | undefined;

    constructor(data?: IMeterWithMeterReadsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.meter = _data["meter"] ? MeterDto.fromJS(_data["meter"]) : <any>undefined;
            if (Array.isArray(_data["meterReads"])) {
                this.meterReads = [] as any;
                for (let item of _data["meterReads"])
                    this.meterReads!.push(MeterReadDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MeterWithMeterReadsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MeterWithMeterReadsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["meter"] = this.meter ? this.meter.toJSON() : <any>undefined;
        if (Array.isArray(this.meterReads)) {
            data["meterReads"] = [];
            for (let item of this.meterReads)
                data["meterReads"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMeterWithMeterReadsDto {
    meter?: MeterDto;
    meterReads?: MeterReadDto[] | undefined;
}

export class Payment implements IPayment {
    id?: number;
    customerId?: number;
    descripton?: string | undefined;
    amount?: number;
    date?: Date;
    documentIds?: PaymentInfo[] | undefined;

    constructor(data?: IPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.descripton = _data["descripton"];
            this.amount = _data["amount"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(PaymentInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Payment {
        data = typeof data === 'object' ? data : {};
        let result = new Payment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["descripton"] = this.descripton;
        data["amount"] = this.amount;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPayment {
    id?: number;
    customerId?: number;
    descripton?: string | undefined;
    amount?: number;
    date?: Date;
    documentIds?: PaymentInfo[] | undefined;
}

export class PaymentDto implements IPaymentDto {
    id?: number;
    customerId?: number;
    descripton?: string | undefined;
    amount?: number;
    date?: Date;
    documentIds?: PaymentInfoDto[] | undefined;

    constructor(data?: IPaymentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.descripton = _data["descripton"];
            this.amount = _data["amount"];
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>undefined;
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(PaymentInfoDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["descripton"] = this.descripton;
        data["amount"] = this.amount;
        data["date"] = this.date ? this.date.toISOString() : <any>undefined;
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IPaymentDto {
    id?: number;
    customerId?: number;
    descripton?: string | undefined;
    amount?: number;
    date?: Date;
    documentIds?: PaymentInfoDto[] | undefined;
}

export class PaymentInfo implements IPaymentInfo {
    documentId?: number;
    documentType?: string | undefined;

    constructor(data?: IPaymentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentType = _data["documentType"];
        }
    }

    static fromJS(data: any): PaymentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentType"] = this.documentType;
        return data; 
    }
}

export interface IPaymentInfo {
    documentId?: number;
    documentType?: string | undefined;
}

export class PaymentInfoDto implements IPaymentInfoDto {
    documentId?: number;
    documentType?: string | undefined;

    constructor(data?: IPaymentInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentId = _data["documentId"];
            this.documentType = _data["documentType"];
        }
    }

    static fromJS(data: any): PaymentInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId;
        data["documentType"] = this.documentType;
        return data; 
    }
}

export interface IPaymentInfoDto {
    documentId?: number;
    documentType?: string | undefined;
}

export class RegisterRequest implements IRegisterRequest {
    firstName!: string;
    lastName!: string;
    email!: string;
    password!: string;
    acceptTerms?: boolean;

    constructor(data?: IRegisterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.password = _data["password"];
            this.acceptTerms = _data["acceptTerms"];
        }
    }

    static fromJS(data: any): RegisterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["password"] = this.password;
        data["acceptTerms"] = this.acceptTerms;
        return data; 
    }
}

export interface IRegisterRequest {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    acceptTerms?: boolean;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
    token!: string;
    password!: string;

    constructor(data?: IResetPasswordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ResetPasswordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["password"] = this.password;
        return data; 
    }
}

export interface IResetPasswordRequest {
    token: string;
    password: string;
}

export class RevokeTokenRequest implements IRevokeTokenRequest {
    token?: string | undefined;

    constructor(data?: IRevokeTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): RevokeTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RevokeTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data; 
    }
}

export interface IRevokeTokenRequest {
    token?: string | undefined;
}

export enum Role {
    User = "User",
    Admin = "Admin",
}

export class UpdateRequest implements IUpdateRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    password?: string | undefined;

    constructor(data?: IUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): UpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["password"] = this.password;
        return data; 
    }
}

export interface IUpdateRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    password?: string | undefined;
}

export class ValidateResetTokenRequest implements IValidateResetTokenRequest {
    token!: string;

    constructor(data?: IValidateResetTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): ValidateResetTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateResetTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data; 
    }
}

export interface IValidateResetTokenRequest {
    token: string;
}

export class VerifyEmailRequest implements IVerifyEmailRequest {
    token!: string;

    constructor(data?: IVerifyEmailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): VerifyEmailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VerifyEmailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        return data; 
    }
}

export interface IVerifyEmailRequest {
    token: string;
}
